import { MainSocket } from '../../../shared/services/mainSocketClass';
import { getCustomerId } from '../../../shared/utils/user';
import { getWsInterface } from '../../../spa/Utils/Websockets';

export const WS_CONNECTION_NAME = 'betcards';
const WS_BETCARDS_NEW_BETS_ACTION = 'forward_new_bet';

export class BetfeedSocket extends MainSocket {

    constructor(wsInterface) {
        super(wsInterface);
        this.wsConectionName = WS_CONNECTION_NAME;
        this.wsInterface = wsInterface;
    }

    /**
     * Register event handlers
     * @override
     */
    setWsEventHandlers() {
        this.wsInterface.requestHandler(this.wsConectionName).registerHandler(WS_BETCARDS_NEW_BETS_ACTION, this.wsEventUpdateHandler);
    }

    /**
     * Starts listening for ws updates
     * @override
     */
    subscribeForUpdates(betcardIds) {

        if (betcardIds.length) {
            const customerId = getCustomerId();
            const payload = {
                'action': 'register',
                'customer_id': customerId,
                'betcard_ids': betcardIds,
            };

            this.wsInterface.requestHandler(this.wsConectionName).subscribeTo(payload);
            if (!this.isWsEventHandlersSet) {
                this.wsInterface.onCloseConnections(() => {
                    this.isWsEventHandlersSet = false;
                });

                this.setWsEventHandlers();
                this.isWsEventHandlersSet = true;
            }
        }
    }

    /**
     * Stops listening for ws updates
     * @override
     */
    unsubscribeForUpdates(betcardIds) {
        if (betcardIds.length) {
            const payload = {
                'action': 'unregister',
                'betcard_ids': betcardIds,
            };

            this.wsInterface.requestHandler(this.wsConectionName).subscribeTo(payload);
        }
    }

    /**
     * Returns the data to listen for number of people betted on batcards
     * @override
     */
    getSubscriptionData(betCards) {
        const betcardIds = betCards.map(betcard => betcard.betcard_id);

        return betcardIds;
    }
}

const wsInterface = getWsInterface();
const betfeedSocket = new BetfeedSocket(wsInterface);
export default betfeedSocket;
